// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2827":"5ba58873","5737":"ba61d5a4","7979":"5ba58873"}[chunkId] + ".chunk.css";
};